var _image, _image2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.981,
    height: 47.981,
    viewBox: "0 0 1904 1904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 1904,
    height: 1904,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAcElEQVRoge3asQ2AMBAEwcMipf8KoQEXALJTClidtBN+9JvfkeROcqXTXAFv6fPbWBW/a485ip/fDKAZQDOAZgDNAJoBNANoBtAMoBlAM4BmAM0AmgE0A2gG0AygGUAzgGYAzQBa/djjTPLUzm2S+QE9WQgP+ead8QAAAABJRU5ErkJggg=="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 4,
    y: 4,
    width: 1896,
    height: 1896,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACZElEQVRoge2av4vUQBiGn73zlBU978RCBW0sFOxEEHtPUBFRbKxVtLTawso/QFBBO2ux0+ZQPGz0TxBERcRGBcETN4K/1h2Z2zkymzeZ2SImF8gDU+T9vg3zziTzzYTtGGM+AJtpJok1YBra+RWmrAtRm0My1eDOr9AaqJvWQN1MauAWsAAcAE4C9ySjLowxfRPmhC0VOa0X/FU19G0h6wcq8X3gnKgpr4C9olZHtA4sijLOY1EqJmZgkyjjzIqyxgycF2WcU6JUTMzAQeCmqLAFeAJslUjFxF7iVV665/0rsBs4DWyTrOpJJjWwVknW1dyx78AvYCPQlegExAzY09odUUfMAT3vehm4LlkjbOeuAtPAF+A28Ah47RnYBxwFLgA75Q5FRCrx85wK7Lehl/smJ+43yzNjzHxOzG9dY8xd6Uk+/dgMhKZ1V+Z6g10U7JhIJhwGngJHJKL8cLMwAC5JNENVu9H3wHFRw1wG3gYzSjZgCkbf8gn4LWqcXiyjzFVoxt1vIJFxbHE85PKWgHeSkfLA1Z55iTjKNDA9wYzeAK5413bGzgAPJTPFvjtnRXVUeSK7mOm8peNGObQpfCGKR5kG/gJDUUfYjl4TNeWYKCmfRfEo08AfZyIPu/nbnqOvEjoU/RTFo0wDHVFSZpzBItYX6FGqegeGgceLyMoVGpj2u1DttAbqpjVQN2UaGAR2o/+NMg2E1vnaDIT28B8z10XbCNw5ODQ730RJWRbFI7adnnWH7Tx2ZLRuIHcuMlh7Ar/dL4pH478LhUalEbQG6qY1UDeN/7OHrQO2IDVzGYXkHyfRyJlHyNSoAAAAAElFTkSuQmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.35cffaaf81a5fb46aecdc60916502b37.svg";
export { ForwardRef as ReactComponent };